<template>
<li class="header-categories-dropdown-category">
  <div class="relative text-sm font-medium flex justify-between">
    <button
      v-if="hasChildren"
      @click="expanded = !expanded"
      v-bind="backgroundButtonComonProps"
    ></button>
    <router-link
      v-else
      :to="thisCategoryLinkObj"
      v-bind="backgroundButtonComonProps"
    ></router-link>

    <router-link
      :to="thisCategoryLinkObj"
      class="header-categories-dropdown-category__this-category-text-link block mx-4 my-3 relative"
    >{{ category.name }}</router-link>
    <button
      v-if="hasChildren"
      @click="expanded = !expanded"
      class="px-4 relative"
      type="button"
    >
      <i
        class="fa fa-caret-down text-xs"
        data-fa-transform="rotate-180"
        style="transition: transform 0.18s;"
        :style="{ 'transform': expanded ? 'rotate(180deg)' : undefined }"
      />
    </button>
  </div>
  <template v-if="hasChildren">
    <AsyncTransitionExpand>
      <ul v-if="expanded" class="ml-4">
        <header-categories-dropdown-category
          v-for="child of category.children"
          :key="child.id"
          :category="child"
        />
      </ul>
    </AsyncTransitionExpand>
  </template>
</li>
</template>

<script>
import AsyncTransitionExpand from '@/components/AsyncTransitionExpand';

export default {
  name: 'header-categories-dropdown-category',
  components: {
    AsyncTransitionExpand,
  },
  props: {
    category: {
      type: Object,
      required: true,
    },
  },
  computed: {
    hasChildren() {
      return this.category.children?.length > 0;
    },
    backgroundButtonComonProps() {
      return {
        tabindex: '-1',
        class: 'absolute inset-0 h-full w-full focus:outline-none'
      };
    },
    thisCategoryLinkObj() {
      return {
        name: 'catalog',
        params: {
          categoryId: this.category.short_id,
          categorySlug: this.category.slug,
        }
      };
    }
  },
  data() {
    return {
      expanded: false,
    };
  },
}
</script>

<style lang="less">
.header-categories-dropdown-category {
  &__this-category-text-link {
    &.router-link-active, &:focus, &:hover {
      @apply text-primary;
    }
  }
}
</style>
